import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { Constants } from '../constants';
import { API_URL } from '../constants/api-url.constants';
import { ServerMessage } from '../models';
import { AppToasterService, CommonService } from '../services';

const SLOT_CONFLICT_URL = new RegExp(
  `/${API_URL.scheduleLessonDetails.root}/(${API_URL.crud.create}|${API_URL.crud.update}|${API_URL.scheduleLessonDetails.createBulkIntroductoryScheduleLessons})$`,
  'i'
);
export const MAKE_UP_PASS_ALREADY_USED = 'MakeUpPassAlreadyUsed';

@Injectable({ providedIn: 'root' })
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly commonService: CommonService,
    private readonly toasterService: AppToasterService,
    private readonly dialog: MatDialog
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.commonService.isApiCallInProgress$.next(true);
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.commonService.isApiCallInProgress$.next(false);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.commonService.isApiCallInProgress$.next(false);
        const errorResponse: ServerMessage = error.error?.error;
        if (HttpStatusCode.Conflict === error.status && SLOT_CONFLICT_URL.test(request.url)) {
          return this.showConflictDialog(errorResponse?.details === MAKE_UP_PASS_ALREADY_USED)
            .afterClosed()
            .pipe(switchMap(() => throwError(() => error)));
        }
        if (errorResponse?.message) {
          if (401 === error.status) {
            this.toasterService.error(errorResponse.message);
            this.authService.logOut();
            return throwError(() => error);
          } else {
            this.toasterService.error(errorResponse.message);
            return throwError(() => error);
          }
        } else {
          this.toasterService.error('Something went wrong!');
          return throwError(() => error);
        }
      })
    );
  }

  private showConflictDialog(isMakeUpPassUsed: boolean): MatDialogRef<ConfirmationDialogComponent> {
    return this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: isMakeUpPassUsed ? 'Make-up Pass Already Used' : 'Slot No Longer Available',
        message: isMakeUpPassUsed ? Constants.errorMessages.makeUpPassAlreadyUsed : Constants.errorMessages.slotNoLongerAvailable,
        acceptBtnName: 'OK',
        hideRejectBtn: true
      }
    });
  }
}
